import { Link } from "react-router-dom";
import "./Home.css";

const UPDATED_AT = "1 de junio de 2026";

const BUSINESS = {
  legalName: "NEON MUSIC COCKTAIL & PUB SL",
  tradeName: "NEON Music Cocktail",
  nif: "B24791212",
  address: "C. de la Coruña, 16, 28805 Alcalá de Henares, Madrid",
  phone: "614807628",
  email: "neon.info@weltascorp.com",
  domain: "neonmusicycocktail.es",
};

function LegalShell({ title, intro, children }) {
  return (
    <main className="legal-page">
      <section className="nh-section legal-page-inner" aria-labelledby="legal-title">
        <div className="nh-section-head legal-head">
          <p className="legal-kicker">NEON Music Cocktail</p>
          <h1 id="legal-title" className="nh-section-title">{title}</h1>
          <p className="nh-section-sub">{intro}</p>
          <p className="legal-updated">Última actualización: {UPDATED_AT}</p>
        </div>

        <div className="legal-content">
          {children}
        </div>

        <nav className="legal-nav" aria-label="Documentación legal">
          <Link to="/aviso-legal">Aviso legal</Link>
          <Link to="/privacidad">Privacidad</Link>
          <Link to="/eliminacion-datos">Eliminación de datos</Link>
          <Link to="/politica-cookies">Cookies</Link>
          <Link to="/condiciones-reservas">Condiciones</Link>
        </nav>
      </section>
    </main>
  );
}

function InfoBox() {
  return (
    <div className="legal-info-box">
      <p><strong>Responsable:</strong> {BUSINESS.legalName}</p>
      <p><strong>NIF:</strong> {BUSINESS.nif}</p>
      <p><strong>Domicilio:</strong> {BUSINESS.address}</p>
      <p><strong>Teléfono:</strong> <a href={`tel:+34${BUSINESS.phone}`}>614 80 76 28</a></p>
      <p><strong>Email:</strong> <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a></p>
      <p><strong>Dominio:</strong> {BUSINESS.domain}</p>
    </div>
  );
}

export function AvisoLegal() {
  return (
    <LegalShell
      title="Aviso legal"
      intro="Información identificativa del titular de la web y condiciones generales de uso."
    >
      <section>
        <h2>1. Titular del sitio web</h2>
        <InfoBox />
      </section>

      <section>
        <h2>2. Objeto</h2>
        <p>
          Este sitio web informa sobre la actividad de {BUSINESS.tradeName}: coctelería, pub, cocina,
          carta digital, eventos, reservas y atención al cliente en el establecimiento indicado.
        </p>
      </section>

      <section>
        <h2>3. Uso de la web</h2>
        <p>
          La persona usuaria se compromete a utilizar la web de forma diligente, lícita y respetuosa,
          sin alterar su seguridad, su disponibilidad ni los sistemas de pedidos, reservas o contacto.
        </p>
      </section>

      <section>
        <h2>4. Propiedad intelectual</h2>
        <p>
          Los textos, fotografías, logotipos, diseño, carta digital y demás contenidos pertenecen a
          {` ${BUSINESS.legalName}`} o se utilizan con autorización. No está permitida su reproducción
          o reutilización comercial sin autorización previa.
        </p>
      </section>

      <section>
        <h2>5. Enlaces externos</h2>
        <p>
          La web puede enlazar a servicios externos como WhatsApp, Google Maps o redes sociales. Al acceder
          a esos servicios se aplicarán sus propias condiciones y políticas de privacidad.
        </p>
      </section>

      <section>
        <h2>6. Legislación aplicable</h2>
        <p>
          Este aviso se rige por la legislación española, incluyendo la Ley 34/2002 de servicios de la
          sociedad de la información y comercio electrónico cuando resulte aplicable.
        </p>
      </section>
    </LegalShell>
  );
}

export function PrivacyPolicy() {
  return (
    <LegalShell
      title="Política de privacidad"
      intro="Cómo tratamos los datos personales recibidos mediante contacto, reservas, carta digital, pedidos de mesa y facturación."
    >
      <section>
        <h2>1. Responsable del tratamiento</h2>
        <InfoBox />
      </section>

      <section>
        <h2>2. Datos que podemos tratar</h2>
        <ul>
          <li>Datos identificativos y de contacto: nombre, teléfono, correo electrónico y mensajes enviados.</li>
          <li>Datos de reserva o evento: fecha, hora, número de personas, preferencias y observaciones facilitadas.</li>
          <li>Datos de pedido en mesa: mesa, productos solicitados, notas del pedido y estado de servicio.</li>
          <li>Datos de facturación cuando se solicite factura: nombre o razón social, NIF, dirección y correo electrónico.</li>
          <li>Datos técnicos: dirección IP, navegador, logs de seguridad y preferencias de cookies.</li>
        </ul>
      </section>

      <section>
        <h2>3. Finalidades</h2>
        <ul>
          <li>Atender consultas, reservas, solicitudes por WhatsApp y comunicaciones de clientes.</li>
          <li>Gestionar pedidos realizados desde la carta digital o QR de mesa.</li>
          <li>Organizar eventos, celebraciones y servicios contratados en el local.</li>
          <li>Emitir tickets, facturas y cumplir obligaciones contables, fiscales y administrativas.</li>
          <li>Proteger la seguridad de la web y mejorar la experiencia, siempre conforme a las preferencias de cookies.</li>
        </ul>
      </section>

      <section>
        <h2>4. Base jurídica</h2>
        <p>
          Tratamos los datos sobre la base de la ejecución de medidas precontractuales o contractuales
          solicitadas por la persona usuaria, el cumplimiento de obligaciones legales, el interés legítimo
          en mantener la seguridad del servicio y el consentimiento cuando sea necesario, por ejemplo para
          cookies no técnicas o comunicaciones comerciales.
        </p>
      </section>

      <section>
        <h2>5. Destinatarios</h2>
        <p>
          No vendemos datos personales. Podrán acceder a los datos proveedores necesarios para prestar el
          servicio, como alojamiento web, mantenimiento técnico, mensajería, facturación, asesoría o servicios
          de comunicación. Si se usan enlaces externos, el tratamiento posterior dependerá de cada proveedor.
        </p>
      </section>

      <section>
        <h2>6. Conservación</h2>
        <p>
          Conservaremos los datos durante el tiempo necesario para atender la solicitud o servicio y, cuando
          exista obligación legal, durante los plazos exigidos por normativa contable, fiscal, administrativa
          o de defensa frente a reclamaciones.
        </p>
      </section>

      <section>
        <h2>7. Derechos</h2>
        <p>
          Puedes solicitar acceso, rectificación, supresión, oposición, limitación, portabilidad y retirada
          del consentimiento escribiendo a <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>.
          También puedes reclamar ante la Agencia Española de Protección de Datos si consideras que el
          tratamiento no se ajusta a la normativa.
        </p>
      </section>

      <section>
        <h2>8. Seguridad</h2>
        <p>
          Aplicamos medidas técnicas y organizativas razonables para proteger la información, incluyendo
          comunicaciones HTTPS, control de acceso en zonas privadas y separación entre rutas públicas,
          mesa QR y administración.
        </p>
      </section>
    </LegalShell>
  );
}

export function UserDataDeletion() {
  return (
    <LegalShell
      title="Eliminación de datos de usuario"
      intro="Instrucciones para solicitar la supresión de datos personales asociados a formularios, reservas, pedidos, eventos o accesos mediante plataformas externas."
    >
      <section>
        <h2>1. Responsable</h2>
        <InfoBox />
      </section>

      <section>
        <h2>2. Cómo solicitar la eliminación</h2>
        <p>
          Para pedir la eliminación de tus datos personales, envía un correo a{" "}
          <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a> con el asunto
          "Eliminación de datos de usuario". Indica el nombre, correo electrónico o teléfono usado
          en la reserva, consulta, pedido o comunicación para poder localizar la información.
        </p>
      </section>

      <section>
        <h2>3. Datos que podemos eliminar</h2>
        <ul>
          <li>Datos de contacto enviados mediante formularios, WhatsApp, teléfono o correo electrónico.</li>
          <li>Datos asociados a reservas, eventos o solicitudes comerciales.</li>
          <li>Datos operativos de pedidos realizados desde la carta digital o QR de mesa, cuando no exista obligación legal de conservarlos.</li>
          <li>Datos recibidos desde plataformas externas, redes sociales o integraciones, si han sido almacenados por {BUSINESS.tradeName}.</li>
        </ul>
      </section>

      <section>
        <h2>4. Plazo de respuesta</h2>
        <p>
          Revisaremos la solicitud y responderemos en un plazo máximo de 30 días naturales. Si necesitamos
          verificar tu identidad o aclarar qué datos deben eliminarse, podremos solicitar información
          adicional antes de completar el proceso.
        </p>
      </section>

      <section>
        <h2>5. Límites legales</h2>
        <p>
          Algunos datos no podrán eliminarse de forma inmediata si deben conservarse por obligaciones
          fiscales, contables, administrativas, de seguridad o para atender posibles reclamaciones. En esos
          casos se bloquearán o limitarán conforme a la normativa aplicable hasta que finalice el plazo legal
          de conservación.
        </p>
      </section>

      <section>
        <h2>6. Plataformas externas</h2>
        <p>
          Si la solicitud está relacionada con Facebook, Instagram, WhatsApp, Google u otra plataforma,
          también puedes gestionar o eliminar tus datos directamente desde la configuración de privacidad de
          dicha plataforma. Esta página cubre los datos que {BUSINESS.tradeName} pueda haber recibido o
          almacenado en sus propios sistemas.
        </p>
      </section>
    </LegalShell>
  );
}

export function CookiesPolicy() {
  return (
    <LegalShell
      title="Política de cookies"
      intro="Información sobre las cookies y tecnologías similares utilizadas por NEON Music Cocktail."
    >
      <section>
        <h2>1. Qué son las cookies</h2>
        <p>
          Las cookies y tecnologías similares permiten guardar o consultar información en el dispositivo de
          la persona usuaria. Pueden ser necesarias para prestar un servicio solicitado o utilizarse, con
          consentimiento, para medición o marketing.
        </p>
      </section>

      <section>
        <h2>2. Cookies que utilizamos</h2>
        <ul>
          <li><strong>Necesarias:</strong> permiten recordar el consentimiento, mantener preferencias técnicas, operar la carta digital, pedidos de mesa, seguridad y rutas de administración.</li>
          <li><strong>Analíticas:</strong> permiten medir visitas, páginas consultadas y uso general de la web para mejorar la carta, eventos y reservas. Solo se activan con consentimiento.</li>
          <li><strong>Marketing:</strong> permiten medir campañas o contenidos promocionales si se configuran herramientas publicitarias. Solo se activan con consentimiento.</li>
        </ul>
      </section>

      <section>
        <h2>3. Gestión del consentimiento</h2>
        <p>
          WeltasCorp Cookie permite aceptar todas las cookies, rechazar las opcionales o configurar cada
          categoría. Las opciones de aceptar y rechazar se presentan al mismo nivel para que la decisión
          sea libre y sencilla.
        </p>
        <button
          className="legal-cookie-manage"
          onClick={() => window.dispatchEvent(new CustomEvent("weltascorp:open-cookies"))}
        >
          Gestionar cookies
        </button>
      </section>

      <section>
        <h2>4. Cookies de terceros</h2>
        <p>
          La web puede enlazar a servicios de terceros como WhatsApp, Google Maps, Instagram o Facebook.
          Esos servicios pueden usar sus propias cookies al abrir sus páginas o aplicaciones, bajo sus
          propias políticas.
        </p>
      </section>

      <section>
        <h2>5. Cambios en la política</h2>
        <p>
          Esta política puede actualizarse si se incorporan nuevas herramientas de medición, publicidad,
          reservas o servicios digitales. La fecha de última actualización se mostrará en esta página.
        </p>
      </section>
    </LegalShell>
  );
}

export function BookingTerms() {
  return (
    <LegalShell
      title="Condiciones de reservas y servicio"
      intro="Condiciones básicas para reservas, eventos, carta digital, pedidos de mesa y funcionamiento del local."
    >
      <section>
        <h2>1. Reservas</h2>
        <p>
          Las reservas solicitadas por WhatsApp, teléfono o web quedan sujetas a confirmación por parte de
          {` ${BUSINESS.tradeName}`}. El local puede solicitar datos de contacto para confirmar horario,
          número de personas y condiciones del servicio.
        </p>
      </section>

      <section>
        <h2>2. Eventos y celebraciones</h2>
        <p>
          Las condiciones particulares de eventos, celebraciones, reservas de grupo, consumiciones mínimas
          o señales se informarán antes de cerrar la reserva cuando resulten aplicables.
        </p>
      </section>

      <section>
        <h2>3. Carta digital y pedidos de mesa</h2>
        <p>
          La carta digital muestra productos, precios y disponibilidad orientativa. Los pedidos enviados desde
          QR de mesa se consideran solicitudes al personal y pueden requerir validación según disponibilidad,
          horarios, aforo, restricciones de cocina o incidencias operativas.
        </p>
      </section>

      <section>
        <h2>4. Precios, alérgenos y consumo responsable</h2>
        <p>
          Los precios pueden actualizarse. Antes de consumir, consulta con el personal cualquier duda sobre
          ingredientes, alérgenos, intolerancias o graduación alcohólica. No se servirá alcohol a menores de
          edad y se aplicará la normativa vigente sobre consumo responsable.
        </p>
      </section>

      <section>
        <h2>5. Cancelaciones e incidencias</h2>
        <p>
          Si no puedes asistir, avisa con antelación por teléfono o WhatsApp. El local podrá reorganizar
          reservas ante retrasos, cambios de aforo, eventos privados, incidencias técnicas o causas de fuerza
          mayor.
        </p>
      </section>
    </LegalShell>
  );
}
